import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserToken } from 'src/app/models/UserToken';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<UserToken>;
  public currentUser: Observable<UserToken>;
  private currentUserDataSubject: BehaviorSubject<any>;
  public currentUserData: Observable<any>;

  constructor() {
    this.currentUserSubject = new BehaviorSubject<UserToken>(
      JSON.parse(localStorage.getItem('currentUser')!)
    );
    this.currentUser = this.currentUserSubject.asObservable();

    this.currentUserDataSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem('loggedUser')!)
    );
    this.currentUserData = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): UserToken {
    // console.log(this.currentUserSubject.value)
    return this.currentUserSubject.value;
  }
  public getCurrentUser(): Observable<any> {
    return this.currentUserSubject.asObservable();
  }

  public getToken() {
    return JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  login(userToken: UserToken) {
    localStorage.setItem('currentUser', JSON.stringify(userToken));
    this.currentUserSubject.next(userToken);
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('loggedUser');
    this.currentUserSubject.next(null!);
    this.currentUserDataSubject.next(null);
  }
  storeUser(userData: any) {
    console.log("Auth Service: loggedUser", userData)
    localStorage.setItem('loggedUser', JSON.stringify(userData));
    this.currentUserDataSubject.next(userData);
  }

  public getLoggedUser() {
    return JSON.parse(localStorage.getItem('loggedUser')!);
  }

  setReportToken(token: string) {
    localStorage.setItem('reportToken', token);
  }

  getReportToken() {
    return localStorage.getItem('reportToken');
  }
}
